import { useState, useEffect } from 'react';
import { ICandidateInterviewFeedbackOverallRating } from '../models/candidateFeedbackOverallRating.model';
import { axiosGetCandidateOverallRating } from '../stateManagement/api';
import { ICandidateInterviewFeedbackInputParams } from '../models/candidateProfile.model';

export const useCandidateOverallRating = ({
  candidateID,
  requisitionID,
}: ICandidateInterviewFeedbackInputParams) => {
  const [aggregateData, setAggregateData] =
    useState<ICandidateInterviewFeedbackOverallRating | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axiosGetCandidateOverallRating({
          requisitionID,
          candidateID,
        });
        setAggregateData(response);
        setError(null);
      } catch (apiError: any) {
        setError(apiError.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { aggregateData, loading, error };
};
